export enum Role {
  User = 'USER',
  Manager = 'MANAGER',
  Vendor = 'VENDOR',
  Admin = 'ADMIN'
}
